import { Resource } from '@/classes';
import { Role } from '@/types';
import { AppResponse } from '@/types';

export default function roles(appConfig: AppResponse) {
  return new Resource<Role>('Roles').withStaticOptions(appConfig.allRoles);
}
